import { LinePath, AreaClosed } from '@visx/shape';
import type { ScaleTime, ScaleLinear } from 'd3-scale';
import type { NormalisedDataPoint } from '../utils/normaliseChartData';
import type { ChartDimensions } from '../types';

interface ChartVisualizationProps {
  keys: number[];
  normalisedEntities: Record<number, NormalisedDataPoint>;
  xScale: ScaleTime<number, number>;
  yScale: ScaleLinear<number, number>;
  dimensions: ChartDimensions;
  fillColor: string;
  strokeColor: string;
}

export const ChartVisualization = ({
  keys,
  normalisedEntities,
  xScale,
  yScale,
  dimensions,
  fillColor,
  strokeColor,
}: ChartVisualizationProps) => {
  return (
    <svg>
      {/* Price line - draws the actual price movement line */}
      <LinePath
        data={keys}
        x={(d) => xScale(d || 0) as number}
        y={(d) => yScale(normalisedEntities[d]?.value || 0) as number}
        stroke={strokeColor}
        strokeWidth={1}
        strokeLinecap="round"
        aria-label="Price line"
        role="img"
      />

      {/* Filled area below price line */}
      <AreaClosed
        data={keys}
        x={(d) => xScale(d || 0) as number}
        y={(d) => yScale(normalisedEntities[d]?.value || 0) as number}
        yScale={yScale}
        fill={fillColor}
        fillOpacity="0.9"
        y0={() => dimensions.height + dimensions.paddingY}
        aria-label="Filled area below price line"
        role="img"
      />
    </svg>
  );
};
